import { Component } from '@opten/compiler/metadata/component';

import { Option, Select } from '@opten/select';

@Component({ className: 'js-select' })
export class SelectComponent {
	private select: Select;

	constructor(private element: HTMLSelectElement) {
		this.select = new Select(element);
	}
}
